// extracted by mini-css-extract-plugin
export var danger = "_3m-6";
export var lightPink = "_3m-a";
export var medium = "_3m-j";
export var nearSquare = "_3m-m";
export var neutralBlue = "_3m-8";
export var neutralYellow = "_3m-7";
export var noCapitalize = "_3m-1";
export var normal = "_3m-2";
export var pill = "_3m-0";
export var primary = "_3m-3";
export var primaryLight = "_3m-4";
export var shadow = "_3m-n";
export var small = "_3m-k";
export var solidBlack = "_3m-i";
export var solidGreen = "_3m-d";
export var solidLightBlue = "_3m-f";
export var solidNavy = "_3m-e";
export var solidOrange = "_3m-h";
export var solidPink = "_3m-g";
export var solidRed = "_3m-b";
export var solidWhite = "_3m-9";
export var solidYellow = "_3m-c";
export var success = "_3m-5";
export var xsmall = "_3m-l";